import { useTranslations } from '@vocab/react';
import { Box, Button } from 'braid-design-system';

import translations from './.vocab';

import * as styles from './ShowRepliesButton.css';

interface ShowRepliesButtonProps {
  replies: number;
  isClicked?: boolean;
  onClick: () => void;
}

export default ({
  replies,
  onClick,
  isClicked = false,
}: ShowRepliesButtonProps) => {
  const { t } = useTranslations(translations);

  return (
    <Box background="body" className={styles.ShowReplyButton}>
      <Button tone="formAccent" variant="transparent" onClick={onClick}>
        {' '}
        {isClicked ? t('hide') : t('show')} {replies}{' '}
        {replies > 1 ? t('replies') : t('reply')}
      </Button>
    </Box>
  );
};
